module.exports = __webpack_public_path__ + "media/guests/assets/images/back_document_image-f19323f65649280be5c007a4b16307dd.png";